<script>
  export default {

    name: "Notification",

    props: {
      message: {
        type: String,
      },
      type: {
        type: String,
      },
    },

    mounted() {
      this.showNotification();
    },

    methods: {
      showNotification() {
        switch (this.type) {
          case 'success': this.$toasted.global.toastSuccess({ message: this.message }); break;
          case 'errors': this.$toasted.global.toastError({ message: this.message }); break;
          default: this.$toasted.global.toastDefault({ message: this.message }); break;
        }
      }
    },

  }
</script>